export default function xorGuids(str, key) {
  if (!str || !key) {
    return null;
  }

  return _.reduce(_.zip(str.split(''), key.split('')), function (acc, [a, b]) {
    a = parseInt(a, 16);
    b = parseInt(b, 16);

    if (!isNaN(a) && !isNaN(b)) {
      return acc + (a ^ b).toString(16); // eslint-disable-line no-bitwise
    }
    return `${acc}-`;
  }, '');
}



// WEBPACK FOOTER //
// ./src/shared/utils/xor-guids.js